import { trpc } from '@tencent/tpro_rmonitor_web_server_traffic';
import { CardProps } from 'antd';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import i18n from '@/i18n';
import { formatByte2Mb } from '@/infrastructure/utils/digit';
import { ErrorInfo, getDefaultErrorInfo, ProblemDetailInfo } from '@/presentation/components/problem-detail-info';
import { EXCEPTION_TYPE_SORT, ExceptionTypeEnum } from '@/presentation/pages/traffic/config';
import { WithTypeCast } from '@raft/utils';

type IDetailInfo = WithTypeCast<trpc.rmonitor.web_server.IDetailInfo>;

const getExceptionText = (exceptionType: ExceptionTypeEnum) => {
  if (exceptionType === ExceptionTypeEnum.None) return [];

  // 转二进制
  const radixStr = Number(exceptionType).toString(2);
  // 补位到6位
  const radixPad = radixStr.padStart(5, '0');
  const texts: string[] = [];
  let k = 0;
  // eslint-disable-next-line @typescript-eslint/prefer-for-of
  for (let i = radixPad.length - 1; i >= 0; i--) {
    const exceptionValue = Number(radixPad[i]);
    if (exceptionValue === 1) {
      const exceptionText = EXCEPTION_TYPE_SORT[k];
      texts.push(exceptionText);
    }

    k += 1;
  }

  return texts;
};

/**
 *
 * @param exceptionType
 */
export const renderTrafficExceptionType = (exceptionType: ExceptionTypeEnum) => {
  if (exceptionType === ExceptionTypeEnum.None) {
    return i18n.t('无异常');
  }

  const exceptions = getExceptionText(exceptionType);

  return exceptions.join('、');
};

export const ErrorDetail: FC<{
  info: IDetailInfo;
  cardProps?: CardProps;
  titleShowIcon?: boolean;
}> = (props) => {
  const { t } = useTranslation();
  const { info, cardProps, titleShowIcon } = props;
  const data = [
    ...getDefaultErrorInfo(info as ErrorInfo, true),
    { label: t('异常流量'), info: formatByte2Mb(info.abnormalTraffic ?? 0) },
    { label: t('异常类型'), info: renderTrafficExceptionType(info.exceptionType ?? 0) },
    { label: t('运营商'), info: info?.operator ?? '' },
    { label: t('进程名'), info: info?.processName ?? '' },
    { label: t('国家/地区'), info: info?.clientCountry || '-'  },
    { label: t('省份'), info: info?.clientProvince || '-'  },
    { label: t('城市'), info: info?.clientCity || '-'  },
  ];

  return <ProblemDetailInfo
    titleShowIcon={titleShowIcon}
    cardProps={cardProps ? cardProps : { bodyStyle: { paddingTop: 12 } }}
    title={t('错误详情')}
    data={data}
  />;
};
